import React from 'react';
import PropTypes from 'prop-types';
import * as commentType from './commentTypes';
import translate from "react-i18next/dist/commonjs/translate";

const CommentActionLabel = ({ animate, commentTypeLabel, t }) => {    
    switch (commentTypeLabel) {
        case commentType.RESOLUTION_PROPOSAL_RECEIVED:
            return <label className={`badge comment-read ${animate ? "flip-in-hor-bottom" : ""}`}>{t("Read")}</label>;
        case commentType.COMMENT_TO_CUSTOMER:
            return <label className={`badge comment-read ${animate ? "flip-in-hor-bottom" : ""}`}>{t("Unread")}</label>;
        default:
            return null;
    }
};

CommentActionLabel.propTypes = {
    animate: PropTypes.bool.isRequired,
    commentTypeLabel: PropTypes.string.isRequired

};

export default translate("translations")(CommentActionLabel);


// WEBPACK FOOTER //
// ./src/incidents/comments/commentActionLabel.js